import {DatabaseCode, toDatabaseCode} from "./database-code";

export type PersonCapabilityType = DatabaseCode

const dispatcher: PersonCapabilityType = {
  code: 'DISPATCHER',
  displayValue: {
    id: 'common.entity.personcapabilitytype.dispatcher',
    defaultMessage: 'Dispatcher',
  },
};

const driver: PersonCapabilityType = {
  code: 'DRIVER',
  displayValue: {
    id: 'common.entity.personcapabilitytype.driver',
    defaultMessage: 'Driver',
  },
};

const fieldTech: PersonCapabilityType = {
  code: 'FIELD_TECH',
  displayValue: {
    id: 'common.entity.personcapabilitytype.fieldtech',
    defaultMessage: 'Field Technician',
  },
};

const backOffice: PersonCapabilityType = {
  code: 'BACK_OFFICE',
  displayValue: {
    id: 'common.entity.personcapabilitytype.backoffice',
    defaultMessage: 'Back Office',
  },
};

export const personCapabilityType = {
  dispatcher,
  driver,
  fieldTech,
  backOffice
};

export const personCapabilityTypes = Object.values(personCapabilityType);

export const toPersonCapabilityType = (code: string): PersonCapabilityType => toDatabaseCode(code, personCapabilityTypes);
export const toPersonCapabilityTypeSafely = (code: string | undefined): PersonCapabilityType | undefined => code ? toDatabaseCode(code, personCapabilityTypes) : undefined;
